import styled from "styled-components";

const HomeExtortionWrap = styled.div`
background: linear-gradient(to top,#fff,#fff);
padding: 72px 0 0 0;
`

export default HomeExtortionWrap